import { useTranslations } from '@/i18n/use-translations';
import Modal from '@/components/common/modal';

const InsufficientStorageContactModal = ({ open, onModalClose }: { open: boolean; onModalClose: () => void }) => {
  const t = useTranslations();

  return (
    <Modal
      open={open}
      handleClose={onModalClose}
      size="md"
      data-testid="insufficient-storage-contact-modal"
      title={t('media.insufficientStorageContactModalTitle')}
      description={t('media.insufficientStorageContactModalText')}
    />
  );
};

export default InsufficientStorageContactModal;
